import { Button, Tooltip } from "@dit/core-frontend"
import { Box } from "@mos-cat/ds"
import React from "react"
import { buttonProps } from "./buttonProps"
import { REDO_COMMAND, UNDO_COMMAND } from "lexical"
import { NextIcon, PrevIcon } from "../../theme/editorIcons"
import { memo } from "react"

export const UndoRedoButtons = memo(({ activeEditor, isEditable, canUndo, canRedo }) => {
  return (
    <Box display="flex" alignItems="center" gridGap="7px">
      <Tooltip content="Отменить ввод">
        <Button
          {...buttonProps}
          kind="borderless"
          vertSize="32"
          disabled={!canUndo || !isEditable}
          onClick={() => {
            activeEditor.dispatchCommand(UNDO_COMMAND, undefined)
          }}
          title="Undo"
          type="button"
          className=""
        >
          <PrevIcon />
        </Button>
      </Tooltip>

      <Tooltip content="Вернуть ввод">
        <Button
          {...buttonProps}
          kind="borderless"
          vertSize="32"
          disabled={!canRedo || !isEditable}
          onClick={() => {
            activeEditor.dispatchCommand(REDO_COMMAND, undefined)
          }}
          title="Redo"
          type="button"
          className=""
        >
          <NextIcon />
        </Button>
      </Tooltip>
    </Box>
  )
})
UndoRedoButtons.displayName = "UndoRedoButtonsComp"
